<template>
  <v-dialog
    scrollable
    content-class="vis-dialog"
    :value="isVisible"
    :fullscreen="isSm"
    :transition="'dialog-bottom-transition'"
    :width="dialogWidth"
    @input="v => v || $dismiss()"
  >
    <div class="vis-dialog-content">
      <!-- este v-if garante que o VisContainer seja destruído
        quando a popup fecha, o que evita problemas com o reuso
        do componente (e.g. telas como a home do veículo, onde
        cada aba tem um VisDialog, que não é destruído quando
        muda de aba) -->
      <VisContainer
        v-if="isVisible"
        :orgCode="orgCode"
        :tripId="tripId"
        :openInNewVisible="true"
        :dismissVisible="true"
        @click:dismiss="dismiss"
        prefsKeyPrefix="AdminDialog"
        @forceClosed="onForceClosed"
      />
    </div>
  </v-dialog>
</template>

<script>
import VisContainer from './VisContainer.vue'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    VisContainer
  },
  data() {
    return {
      orgId: null,
      tripId: null,
      tripChanged: false
    }
  },
  computed: {
    maxW() {
      return document.documentElement.clientWidth
    },
    dialogWidth() {
      if (this.isSm) return this.maxW
      else return this.maxW - 120
    },
    isSm() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    open({ orgId, tripId /*lapseIndex, navBy = 'vehicle' */ }) {
      this.orgCode = orgId
      this.tripId = tripId
      return this.$open()
    },

    onForceClosed() {
      this.tripChanged = true
    },

    dismiss() {
      this.$apply(this.tripChanged)
    }
  }
}
</script>

<style lang="sass">
.vis-dialog-content
  background-color: white
  position: relative
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
  height: calc(100vh - 120px)
</style>
